import * as React from "react";
import {
	LibraryCard,
	CardType,
	CardPropertyType,
} from "../../types/LibraryCard";
import HistoryIcon from "@material-ui/icons/History";
import CardHistoryItem from "./CardHistoryItem/CardHistoryItem";
import { differenceInDays } from "date-fns";
import { parseISO } from "date-fns/esm";
import { CallbacksContext } from "../BookCalendar/BookCalendar";
import {
	editHistoryItem,
	removeHistoryItem,
} from "../../store/calendar/actions";
import hideHistory from "../../requests/hideHistory";
import { connect } from "react-redux";
import "./CardHistory.css";
import Button from "../Button/Button";
import MediaQuery from "react-responsive";
import Drawer from "@material-ui/core/Drawer/Drawer";
import EditBookCard from "../EditBookCard/EditBookCard";
import { MOBILE_MAX_WIDTH } from "../../utils";
import PopupEditBookCard from "../PopupEditBookCard/PopupEditBookCard";
import editHistoryRequest from "../../requests/editHistory";

interface Props {
	card: LibraryCard;
}

export interface DatePeriod {
	id?: number;
	start?: any;
	end?: any;
	type: CardType;
}

interface DispatchProps {
	removeHistory: typeof removeHistoryItem;
	editHistory: typeof editHistoryItem;
}

const CardHistory: React.FC<Props & DispatchProps> = ({
	card,
	removeHistory,
	editHistory: editHistoryRedux,
}) => {
	const callbacks = React.useContext(CallbacksContext);
	const [addBookDate, setBookDate] = React.useState(false);
	const [editBook, setEditBook] = React.useState(false);
	const [history, setHistory] = React.useState<DatePeriod>(null);

	const popupClose = () => {
		setBookDate(false);
		setEditBook(false);
		setHistory(null);
	};

	const datesArray = React.useMemo(() => {
		const tmp: DatePeriod[] = [];

		card.history.forEach((item) => {
			tmp.push({
				start: item.startDate,
				end: item.finishDate,
				type: CardType.AlreadyRead,
				id: item.id,
			});
		});

		if (card.history.length === 0 || card.cardType !== CardType.AlreadyRead) {
			tmp.push({
				start: card.properties[CardPropertyType.DateBegin],
				end: card.properties[CardPropertyType.DateFinish],
				type: card.cardType,
			});
		}

		return tmp.sort((a, b) => {
			if (!a.start) {
				return -1;
			}

			if (!b.start) {
				return 1;
			}

			return differenceInDays(parseISO(b.start), parseISO(a.start));
		});
	}, [card]);

	const removeFromHistory = (id: number) => {
		hideHistory({
			cardId: card.eId,
			historyId: id,
		});

		removeHistory({
			cardId: card.eId,
			historyId: id,
		});
	};

	const goToCalendar = (start: any) => {
		const iso = parseISO(start);

		window.location.href = `/calendar/#/${iso.getFullYear()}/${iso.getMonth()}/${
			card.eId
		}`;
	};

	const edit = () => {
		setEditBook(true);
	};

	const editHistory = (period: DatePeriod) => {
		setHistory(period);
	};

	const onEditHistoryHandler = (period: DatePeriod) => {
		const request = async () => {
			return editHistoryRequest({
				cardId: card.eId,
				historyId: period.id,
				startDate: period.start,
				endDate: period.end,
			});
		};

		editHistoryRedux({
			cardId: card.eId,
			historyId: period.id,
			start: period.start,
			end: period.end,
		});

		return request();
	};

	return (
		<div>
			<div>
				<div className="cardHistory-header">
					<div className="cardHistory-header__text">
						<HistoryIcon />
						Хронология
					</div>
					<Button
						className="cardHistory-header__button"
						onClick={() => setBookDate(true)}
					>
						Добавить дату
					</Button>
				</div>
			</div>

			<div>
				{datesArray.map((date, key) => (
					<CardHistoryItem
						period={date}
						key={key}
						remove={removeFromHistory}
						goToCalendar={goToCalendar}
						edit={edit}
						editHistory={editHistory}
					/>
				))}
			</div>

			<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
				<Drawer
					open={addBookDate || editBook || !!history}
					anchor="bottom"
					onClose={popupClose}
				>
					<EditBookCard
						onClose={popupClose}
						libraryCard={card}
						onlyHistoryAdd={addBookDate}
						forcedSection={addBookDate ? CardType.AlreadyRead : null}
						book={card.book}
						onSaved={popupClose}
						saveCard={callbacks.addCard}
						saveProperties={callbacks.saveCardProperties}
						hideBookCard={true}
						periodEdit={history}
						onHistoryEdit={onEditHistoryHandler}
					/>
				</Drawer>
			</MediaQuery>

			<MediaQuery minWidth={MOBILE_MAX_WIDTH}>
				<PopupEditBookCard
					open={addBookDate || editBook || !!history}
					onClose={popupClose}
					libraryCard={card}
					onlyHistoryAdd={addBookDate}
					forcedSection={addBookDate ? CardType.AlreadyRead : null}
					book={card.book}
					onSaved={popupClose}
					saveCard={callbacks.addCard}
					saveProperties={callbacks.saveCardProperties}
					periodEdit={history}
					onHistoryEdit={onEditHistoryHandler}
				/>
			</MediaQuery>
		</div>
	);
};

export default connect(() => {}, {
	removeHistory: removeHistoryItem,
	editHistory: editHistoryItem,
})(CardHistory);
